import { useEffect, useState } from 'react'
import useSWR from 'swr'

import { fetcher } from '@/lib/fetcher'

type UseMasterMemoryOptions = {
  enabled?: boolean
}

export function useMasterMemory({ enabled = true }: UseMasterMemoryOptions = {}) {
  const [available, setAvailable] = useState(true)

  useEffect(() => {
    setAvailable(Boolean(enabled))
  }, [enabled])

  const shouldFetch = enabled && available

  const { data, error, isLoading, mutate } = useSWR<{
    memory: Record<string, Array<Record<string, unknown>>>
  }>(shouldFetch ? '/master/memory' : null, fetcher, {
    refreshInterval: shouldFetch ? 10000 : 0,
    revalidateOnFocus: shouldFetch,
    onError: (err) => {
      if ((err as { status?: number } | undefined)?.status === 404) {
        setAvailable(false)
      }
    },
  })

  return {
    entries: data?.memory ?? {},
    loading: shouldFetch ? Boolean(isLoading) : false,
    error: shouldFetch ? error : null,
    refresh: mutate,
    available: enabled && available,
  }
}
